if (!customElements.get('m-newsletter-popup')) {
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('[data-popup-overlay]');
      this.closeBtn = this.querySelector('[data-popup-close]');
      this.noThanksBtn = this.querySelector('[data-popup-no-thanks]');
      this.form = this.querySelector('form');
      this.successEl = this.querySelector('[data-popup-success]');
      this.formEl = this.querySelector('[data-popup-form]');
      this.dismissDays = parseInt(this.dataset.dismissDays || '7', 10);
      this.storageKey = 'wewalk-newsletter-popup';
      this.shown = false;

      this.idleEnabled = this.dataset.idleEnable === 'true';
      this.idleDelay = parseInt(this.dataset.idleDelay || '5', 10) * 1000;

      this.scrollEnabled = this.dataset.scrollEnable === 'true';
      this.scrollDelay = parseInt(this.dataset.scrollDelay || '10', 10) * 1000;
    }

    connectedCallback() {
      this.bindCloseEvents();

      if (Shopify.designMode) {
        this.show();
        return;
      }

      if (this.dataset.enable !== 'true') return;
      if (this.wasRecentlyDismissed()) return;

      // Trigger 1: Idle (no mouse movement)
      if (this.idleEnabled) {
        this.startIdleWatch();
      }

      // Trigger 2: After scroll/navigation
      if (this.scrollEnabled) {
        this.startScrollWatch();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    // --- Idle trigger ---
    startIdleWatch() {
      this.idleTimer = setTimeout(() => this.triggerShow(), this.idleDelay);
      this.onMouseMove = () => this.resetIdleTimer();
      this.onKeyDown = () => this.resetIdleTimer();
      document.addEventListener('mousemove', this.onMouseMove, { passive: true });
      document.addEventListener('keydown', this.onKeyDown, { passive: true });
    }

    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      if (!this.shown) {
        this.idleTimer = setTimeout(() => this.triggerShow(), this.idleDelay);
      }
    }

    // --- Scroll trigger ---
    startScrollWatch() {
      this.onScroll = () => {
        window.removeEventListener('scroll', this.onScroll);
        this.scrollTimer = setTimeout(() => this.triggerShow(), this.scrollDelay);
      };
      window.addEventListener('scroll', this.onScroll, { once: true, passive: true });
    }

    // --- Common ---
    triggerShow() {
      if (this.shown) return;
      this.show();
      this.cleanup();
    }

    cleanup() {
      clearTimeout(this.idleTimer);
      clearTimeout(this.scrollTimer);
      if (this.onMouseMove) document.removeEventListener('mousemove', this.onMouseMove);
      if (this.onKeyDown) document.removeEventListener('keydown', this.onKeyDown);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    bindCloseEvents() {
      this.closeBtn?.addEventListener('click', () => this.dismiss());
      this.noThanksBtn?.addEventListener('click', () => this.dismiss());
      this.overlay?.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.dismiss();
      });
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
    }

    wasRecentlyDismissed() {
      try {
        var dismissed = localStorage.getItem(this.storageKey);
        if (!dismissed) return false;
        var dismissDate = new Date(parseInt(dismissed, 10));
        var now = new Date();
        var diffDays = (now - dismissDate) / (1000 * 60 * 60 * 24);
        return diffDays < this.dismissDays;
      } catch (e) {
        return false;
      }
    }

    setDismissed() {
      try {
        localStorage.setItem(this.storageKey, Date.now().toString());
      } catch (e) {}
    }

    show() {
      if (this.shown) return;
      this.shown = true;
      this.overlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    hide() {
      this.overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    dismiss() {
      this.hide();
      this.setDismissed();
    }

    handleSubmit(e) {
      e.preventDefault();
      var formData = new FormData(this.form);

      fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(() => {
        if (this.formEl) this.formEl.style.display = 'none';
        if (this.successEl) this.successEl.style.display = 'block';
        this.setDismissed();
        setTimeout(() => this.hide(), 3000);
      }).catch(() => {
        if (this.formEl) this.formEl.style.display = 'none';
        if (this.successEl) this.successEl.style.display = 'block';
        this.setDismissed();
        setTimeout(() => this.hide(), 3000);
      });
    }
  }

  customElements.define('m-newsletter-popup', NewsletterPopup);
}
